module.exports = __webpack_public_path__ + "img/gas.b08974be.svg";